'use client';

import { ReactElement } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItem as CartItemCard } from './cart-item/cart-item.component';
import { CartLaboratoryGroup } from './cart-laboratory-group/cart-laboratory-group.component';
import { CartProfessionalGroup } from './cart-professional-group/cart-professional-group.component';

import { CartItem } from '@/types/cart.types';
import { CartGroupTypeEnum, CartItemGroup, groupCartItems } from '@/utils/cart/group-cart-items.util';

function noop() {}

interface CartItemsListProps {
  items: CartItem[];
}

function renderGroup(group: CartItemGroup): ReactElement {
  switch (group.type) {
    case CartGroupTypeEnum.LABORATORY:
      return (
        <CartLaboratoryGroup
          items={group.items}
          onEditSchedule={noop}
          onEditPatient={noop}
          onRemoveExam={noop}
          onRemoveAll={noop}
        />
      );

    case CartGroupTypeEnum.PROFESSIONAL:
      return (
        <CartProfessionalGroup
          items={group.items}
          onEditSchedule={noop}
          onEditPatient={noop}
          onRemove={noop}
        />
      );

    case CartGroupTypeEnum.SINGLE:
      return (
        <CartItemCard
          item={group.items[0]}
          onEditSchedule={noop}
          onEditPatient={noop}
          onRemove={noop}
        />
      );
  }
}

export function CartItemsList({ items }: CartItemsListProps) {
  const groups = groupCartItems(items);

  return (
    <ul
      className="flex flex-col gap-4 px-6 pb-5"
      data-testid={DataTestIdEnum.CART_ITEMS_LIST}
    >
      {groups.map((group) => (
        <li key={group.id}>{renderGroup(group)}</li>
      ))}
    </ul>
  );
}
